var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighLow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13476_65502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8785 47.7448C26.1967 48.2941 20.5529 48.1277 19.3711 47.5861C14.6439 45.4197 12.4582 42.988 11.9126 37.4579C11.3669 31.9278 11.8743 28.4203 16.3209 24.9581C17.3247 24.208 21.8169 22.0867 23.9191 22.0601C30.8052 21.9158 37.275 27.9608 37.9988 34.7825C38.7226 41.6043 34.2911 45.5135 27.8785 47.7448Z",
    fill: "#FEDC5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8292 47.6121C25.3786 47.919 22.7233 47.4722 20.2915 47.0178C19.8862 46.942 19.7044 46.8587 19.2915 46.5595C17.515 45.6353 15.6817 44.3552 14.6438 42.7795C13.7953 41.5106 13.2952 39.9615 12.9277 38.363C11.7684 33.2117 11.9083 28.1058 16.7679 24.9428C19.6276 23.5033 23.0251 22.0903 26.2334 23.0106C33.9416 24.6731 39.8624 34.3165 35.6772 41.5286C33.9388 44.3619 30.9124 46.165 27.8292 47.6121L27.8368 47.8356C32.9465 46.7672 38.503 43.0435 39.0254 37.3429C39.9341 29.8393 33.8241 22.5292 26.5364 21.3894C24.6917 21.0941 22.7297 21.2949 21.0972 21.9768C16.0103 23.7156 11.5371 27.7157 11.1472 33.3671C10.4733 39.8783 12.0038 45.4197 18.625 48.014C19.8977 48.5973 21.3295 48.5934 22.7612 48.5896C24.5491 48.5289 26.3369 48.4682 27.9694 47.7863C27.8368 47.8356 27.8292 47.6121 27.8292 47.6121Z",
    fill: "#FEDC5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1761 19.4465C18.9829 17.7079 18.6571 16.0186 18.2896 14.4202C18.1267 13.5755 18.0963 12.6816 17.6683 11.9354C17.1493 11.1476 16.4561 10.4999 15.547 10.0833L15.2819 10.1818C14.8236 11.1818 14.854 12.0757 14.9752 13.0113C15.1381 13.856 15.7404 14.462 16.1685 15.2081C17.0246 16.7005 18.0132 18.1436 19.0436 19.4958C18.911 19.545 19.1761 19.4465 19.1761 19.4465Z",
    fill: "#FEDC5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.93898 37.7269C6.814 37.5413 5.28373 37.28 4.11709 37.1854C3.48832 37.1172 2.89362 36.7347 2.23077 36.9809C1.96563 37.0794 1.56793 37.2272 1.26112 37.4166C0.954324 37.606 0.605862 37.8863 0.306648 38.2992L0.272573 38.6135C0.833195 39.3105 1.42789 39.693 2.19682 39.9354C2.87484 40.1361 3.48844 39.7573 4.15129 39.5111C4.77248 39.3557 5.43533 39.1095 6.09818 38.8633C6.67011 38.5754 7.33296 38.3291 7.9049 38.0412L7.93898 37.7269Z",
    fill: "#FEDC5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8885 29.4151C42.9983 29.1537 44.1005 28.6688 45.2027 28.1839C45.6838 27.8543 46.3542 27.8316 46.6458 27.1952C46.9375 26.5589 47.0473 25.8392 46.8427 25.0854L46.6116 24.8695C45.801 24.7181 45.1306 24.7408 44.5587 25.0287C44.0284 25.2257 43.9602 25.8545 43.6194 26.3583C43.3201 26.7711 42.9793 27.2749 42.6801 27.6878C42.3392 28.1916 42.04 28.6045 41.79 29.1499C41.6991 29.1083 41.8885 29.4151 41.8885 29.4151Z",
    fill: "#FEDC5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.37414 25.9543C8.22641 25.0983 7.16958 24.284 6.02185 23.428C5.42715 23.0455 5.04835 22.4319 4.32866 22.3221C3.51807 22.1706 2.80598 22.2843 1.87799 22.629L1.75301 22.9017C1.96517 23.8789 2.34397 24.4926 2.98792 25.0077C3.54096 25.4811 4.34396 25.4091 5.02198 25.6098C6.41968 25.9203 7.85904 26.14 9.24916 26.227L9.37414 25.9543Z",
    fill: "#FEDC5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9266 18.0296C32.5175 16.9803 33.2901 16.0144 33.881 14.9652C34.2219 14.4614 34.7446 14.0409 34.7711 13.503C34.8392 12.8743 34.7748 12.2947 34.2975 11.416L34.0248 11.291C33.0892 11.4123 32.4756 11.7911 32.0021 12.3441C31.5704 12.8062 31.684 13.5183 31.6159 14.1471C31.4796 15.4047 31.3433 16.6622 31.6123 17.9955C31.6123 17.9955 31.9266 18.0296 31.9266 18.0296Z",
    fill: "#FEDC5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.974 47.1659C10.5157 47.7076 9.14836 48.291 7.83024 49.007C7.12573 49.3441 6.28107 49.507 5.89853 50.1017C5.34176 50.8366 5.00847 51.5638 4.90625 52.507L5.13731 52.7229C6.12972 52.9577 6.88348 52.7531 7.67889 52.4576C8.34174 52.2114 8.71669 51.3932 9.28105 50.8818C10.3188 49.8174 11.3074 48.6204 12.205 47.3818L11.974 47.1659Z",
    fill: "#FEDC5D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.988 38.2504C68.2392 38.6422 77.6777 29.839 78.0696 18.5878C78.3035 11.8712 75.2606 5.80063 70.3763 1.91495C79.8663 3.93549 86.8288 12.5272 86.4794 22.5604C86.0875 33.8116 76.649 42.6148 65.3978 42.2229C60.8631 42.065 56.7262 40.4376 53.4286 37.8142C54.5806 38.0595 55.77 38.2079 56.988 38.2504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.72 48.13C92.72 48.13 92.66 42.43 98.36 42.38C98.36 42.38 92.66 42.44 92.61 36.74C92.61 36.74 92.67 42.44 86.97 42.49C86.97 42.49 92.67 42.43 92.72 48.13Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.64,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.04 6.19001C95.04 6.19001 95.02 3.85001 97.36 3.83001C97.36 3.83001 95.02 3.85001 95 1.51001C95 1.51001 95.02 3.85001 92.68 3.87001C92.68 3.87001 95.02 3.85001 95.04 6.19001Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.21,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.82 18.2001C66.82 18.2001 66.78 14.6301 70.35 14.6001C70.35 14.6001 66.78 14.6401 66.75 11.0701C66.75 11.0701 66.79 14.6401 63.22 14.6701C63.22 14.6701 66.79 14.6301 66.82 18.2001Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.32,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.909 62.2301C78.769 57.2801 78.159 42.6601 62.509 38.8901C55.159 37.1201 48.209 37.4501 42.129 39.8101C40.269 35.9701 34.929 33.5801 34.929 33.5801C24.759 37.3801 23.599 44.3801 23.599 44.3801C25.719 45.2901 28.939 47.3801 31.199 47.3401C29.559 49.1101 28.059 51.1101 26.729 53.3601C25.509 55.2401 23.369 58.8101 20.819 58.8701C19.609 58.9001 16.449 58.4201 14.859 58.3301C13.449 58.1901 13.039 59.6201 13.029 59.9601C12.979 61.7801 12.959 69.7301 13.269 72.0301C14.379 76.6701 20.699 79.1301 28.729 82.0501C29.019 83.2101 29.429 86.6101 29.859 88.1301C29.909 88.3201 29.929 88.5301 30.069 88.6701C30.239 88.8501 30.519 88.8701 30.769 88.8701C32.569 88.9101 33.919 88.8901 35.719 88.7801C35.939 88.7701 36.179 88.7501 36.359 88.6201C36.589 88.4501 36.669 88.1501 36.739 87.8701C36.849 87.4201 36.989 85.0501 37.139 84.4601C47.299 86.7101 58.189 86.7801 64.369 83.2201C64.489 84.0401 64.749 86.8001 65.039 87.8501C65.069 87.9801 65.319 88.4101 65.859 88.3601C66.879 88.3601 69.279 88.3201 70.309 88.3201C70.509 88.3201 70.919 88.2301 71.179 87.6101C74.639 81.4001 79.179 71.4201 78.919 62.2001L78.909 62.2301Z",
    fill: "#FF989A",
    stroke: "#FF989A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.209 54.8601C34.209 54.8601 38.949 51.7601 42.259 58.0101",
    stroke: "#101C1E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.509 58.62C73.509 58.62 79.839 59.17 83.659 53.56C86.629 49.2 84.379 45.84 82.249 46.93C80.819 47.66 80.619 50.44 80.929 51.77C81.679 55 88.749 58.36 88.749 58.36",
    stroke: "#FF989A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.979 48.98C64.4963 48.98 68.969 44.5073 68.969 38.99C68.969 33.4727 64.4963 29 58.979 29C53.4616 29 48.989 33.4727 48.989 38.99C48.989 44.5073 53.4616 48.98 58.979 48.98Z",
    fill: "#FEDC5D",
    stroke: "#FEDC5D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.219 41.7401C62.369 43.0901 60.859 43.9901 59.139 43.9901C56.479 43.9901 54.319 41.8301 54.319 39.1701C54.319 36.5101 56.479 34.3501 59.139 34.3501C60.769 34.3501 62.209 35.1601 63.089 36.4001",
    stroke: "#101C1E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.319 37.8701H60.519",
    stroke: "#101C1E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.319 40.4602H60.519",
    stroke: "#101C1E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.599 59.5899C69.219 53.3699 64.139 46.6699 56.269 44.6199C48.389 42.5699 40.689 45.9499 39.069 52.1699L67.599 59.5999V59.5899Z",
    fill: "#FF989A",
    stroke: "#FF989A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.79 80.19C88.33 73.48 82.36 68.45 75.21 68.45C68.67 68.45 63.55 72.44 61.54 78.3L61.23 78.6299C59.28 77.1599 56.86 76.2799 54.23 76.2799C47.8 76.2799 42.59 81.4899 42.59 87.9199C42.59 94.3499 47.8 99.5599 54.23 99.5599H88.75C94.11 99.5599 98.46 95.2099 98.46 89.8499C98.46 84.8399 94.66 80.7199 89.79 80.1999V80.19Z",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13476_65502"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighLow);
export default __webpack_public_path__ + "static/media/high-low.68a579bda7ee618b56eba4f07dd41b4d.svg";
export { ForwardRef as ReactComponent };